import {JobTypes} from '../credit-loan/LoanDocsPage';

interface Document {
  guid: string;
  title: string;
}

const getUserIndex = (
  userType: 'self' | 'Guarantor-0' | 'Guarantor-1',
): string => {
  switch (userType) {
    case 'self':
      return '0';

    case 'Guarantor-0':
      return '1';

    case 'Guarantor-1':
      return '2';

    default:
      return '';
  }
};

const getJobLetter = (job_type: JobTypes): string => {
  const jobLetterMap: Record<number, string> = {
    1: 'E',

    // Backend changed both to FS
    2: 'FS',
    3: 'FS',
  };

  return jobLetterMap[job_type] || '';
};

// Match new backend format
// Example:
// EXTRA-FS-anything-0-title
// EXTRA-E-anything-1-title
const isMatchingExtraDocument = (
  title: string,
  job_type: JobTypes,
  userType: 'self' | 'Guarantor-0' | 'Guarantor-1',
): boolean => {
  const jobLetter = getJobLetter(job_type);

  const userIndex = getUserIndex(userType);

  if (!jobLetter || userIndex === '') {
    return false;
  }

  const parts = title.split('-');

  // Minimum required structure:
  // EXTRA-FS-anything-0-title
  if (parts.length < 4) {
    return false;
  }

  const formType = parts[0];

  const backendJobLetter = parts[1];

  const backendUserIndex = parts[3];

  return (
    formType === 'EXTRA' &&
    backendJobLetter === jobLetter &&
    backendUserIndex === userIndex
  );
};

// Check if at least one matching document exists
export const hasDocumentsForJobType = (
  documents: Document[],
  job_type: JobTypes,
  userType: 'self' | 'Guarantor-0' | 'Guarantor-1',
): boolean => {
  if (!job_type) {
    return false;
  }

  return documents.some(doc =>
    isMatchingExtraDocument(doc.title, job_type, userType),
  );
};

// Return all matching documents
export const getDocumentsForJobType = (
  documents: Document[],
  job_type: JobTypes,
  userType: 'self' | 'Guarantor-0' | 'Guarantor-1',
): Document[] => {
  if (!job_type) {
    return [];
  }

  return documents.filter(doc =>
    isMatchingExtraDocument(doc.title, job_type, userType),
  );
};
